<template>
	<div class="mb-3">
		<div class="form-floating">
		<select
			@change="$emit('input', $event.target.value)"
			:name='name'
			class="form-select"
			:class="{
				'is-valid': validator && !validator.$error && validator.$dirty,
				'is-invalid': validator && validator.$error,
				inputClass
			}">
			<option v-for="option in options" 
					:value="option.value" 
					:key="option.value"
					:selected="value === option.value"
			>{{ option.label || 'No label' }}</option>
		</select>
		<label :for="name" class="form-label">{{ label }}</label>
		</div>

	</div>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			required: true
		},
		name: {
			type: String,
			required: true
		},
		options: {
			type: Array,
			required: true,
			validator(opts) { return !opts.find(opt => typeof opt !== 'object') }
		},
		value: {
			type: String,
			required: false
		},
		validator: {
			type: Object,
			required: false,
			validator ($v) { return $v.hasOwnProperty('$model'); }
		},
		inputClass: {
			type: String,
			required: false
		},

	}
}
</script>